export const CONSENT_ENDPOINT = '/v1/broker-portal/consent';
export const SSO_ENDPOINT = '/v1/broker-portal/sso';

export const TAG_TYPES: Record<string, string> = {};
